import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { bulkCSVJob } from 'ducks';
import Routes from '../../../../routes';
import BulkUserJobModal from './BulkUserJobModal';

const BulkCSVExport = ({
  className,
  page,
  schoolYearId,
  onClose,
  generateCSV,
  poll,
  cancel
}) => {
  const [job, setJob] = useState();
  const [downloadLink, setDownloadLink] = useState();

  const handleClose = () => (job && job.status === 'pending' ? cancel() : onClose());
  const submitJob = () => {
    const submitPromise = new Promise((resolve, reject) => (
      generateCSV({ school_year_id: schoolYearId, view: page })
        .then(jsonJob => {
          setJob(jsonJob);
          poll(jsonJob)
            .then(resp => {
              setDownloadLink(Routes.api_user_jobs_job_attachment_path('contact_list_csv_export_job', resp.id));
              setJob(resp);
              resolve();
            })
            .catch(error => {
              setJob();
              if (error.status === 'cancelled') {
                onClose();
              } else {
                reject();
              }
            });
        })
        .catch(() => {
          setJob();
          reject();
        })
    ));

    return submitPromise;
  };

  return (
    <BulkUserJobModal
      className={`${className} bulk-csv-export-modal`}
      initialBody='This will export all matching contacts in CSV format. Do you wish to continue? '
      initialTitle='CSV Export'
      workingTitle='CSV Export'
      completedTitle='Download CSV File'
      downloadLink={downloadLink}
      onSubmit={submitJob}
      onClose={handleClose}
    />
  );
};

BulkCSVExport.propTypes = {
  /** className prop */
  className: PropTypes.string,

  /** page prop */
  page: PropTypes.string,

  /** Current school year ID */
  schoolYearId: PropTypes.string,

  /** Function to close and unmount this component */
  onClose: PropTypes.func.isRequired,

  /** Dispatches an action to start the PDF Generation job */
  generateCSV: PropTypes.func.isRequired,

  /** Dispatches an action to poll the status of the PDF Job */
  poll: PropTypes.func.isRequired,

  /** Cancells a poll action for cleanup */
  cancel: PropTypes.func.isRequired
};

BulkCSVExport.defaultProps = {
  className: '',
  page: '',
  schoolYearId: ','
};

const mapDispatchToProps = (dispatch) => ({
  generateCSV: data => dispatch(bulkCSVJob.actions.create({ data: { params: data } }))
    .then(bulkCSVJob.actions.denormalizeObjects),
  poll: job => dispatch(bulkCSVJob.actions.poll(job)).then(bulkCSVJob.actions.denormalizeObjects),
  cancel: () => dispatch(bulkCSVJob.actions.cancelPoll())
});

export default connect(null, mapDispatchToProps)(BulkCSVExport);
